import { createContext, useContext } from 'react';

type FieldWarningEvaluationContextValue = {
  // Called on every change: validates the field and marks its warnings stale.
  changeValue: (field: string) => void;
  // Called when a value is final (blur, or a pick in a select): validates the
  // field and, if it is valid, re-evaluates the warnings.
  commitValue: (field: string) => void;
};

export const FieldWarningEvaluationContext =
  createContext<FieldWarningEvaluationContextValue | null>(null);

export function useFieldWarningEvaluation() {
  return useContext(FieldWarningEvaluationContext);
}
